import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './filter_dropdown_box.module.scss';
import { Paper } from '../../../../components/paper/Paper';

type Props = {
  style?: Object;
  className?: string;
};

export const FilterDropdownBox: FC<Props> = ({
  children,
  style,
  className,
}) => (
  <Paper className={classNames(styles.container, className)} style={style}>
    {children}
  </Paper>
);
